var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 120,
    viewBox: "0 0 370 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0L111.962 90H8.03848L60 0Z",
    fill: "#0999B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370 1H280V91H370V1Z",
    fill: "#102D3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221 91C245.853 91 266 70.8528 266 46C266 21.1472 245.853 1 221 1C196.147 1 176 21.1472 176 46C176 70.8528 196.147 91 221 91Z",
    fill: "#4EB072"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116 46C116 70.8518 136.148 91 161 91V1C136.148 1 116 21.1482 116 46Z",
    fill: "#F8815C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotions);
export default __webpack_public_path__ + "static/media/Emotions.760bd9ee394cab9cd7b1a683097d9eaf.svg";
export { ForwardRef as ReactComponent };